import type { SVGProps } from 'react';

const Svg2022UadComment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3H6C4.35 3 3 4.35 3 6v8c0 1.65 1.35 3 3 3h5.64l4.08 3.4a1.99 1.99 0 0 0 2.13.28c.71-.33 1.15-1.03 1.15-1.81v-2.04c1.16-.41 2-1.52 2-2.83V6c0-1.65-1.35-3-3-3m1 11c0 .55-.45 1-1 1s-1 .45-1 1v2.87l-4.08-3.4c-.36-.3-.81-.46-1.28-.46H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M16 7H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1m-2 4H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default Svg2022UadComment;
